// Importing React classes and functions from node modules
import React, { useState, useEffect } from "react";
import { getProfileUsers, getAttendance, createAttendance, updateAttendance, getAllAttendance } from "../data/repository";
import { format } from 'date-fns';

// Functional Component for Login Page
function Attendance(props) {
    
    // Declaration of useState Variables and Hook
    const [users, setUsersData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [attendanceRecords, setAttendanceRecords] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [percentages, setPercentages] = useState({});
    const [genderFilter, setGenderFilter] = useState(props.user.gender === "Male" ? "Male" : props.user.gender === "Female" ? "Female" : "All");
    const currentDate2 = format(new Date(), 'MM/dd/yyyy');

    useEffect(() => {

        // Loads User Details from DB
        async function loadUserDetails() {
            const currentDetails = await getProfileUsers();
            setUsersData(currentDetails)
            setIsLoading(false);
        }

        const loadAttendanceData = async () => {
            const attendance = await getAttendance(currentDate2);
            setAttendanceData(attendance?.attendance || []);

        }

        const loadAllAttendanceData = async () => {
            const attendance = await getAllAttendance();
            const lastFiveRecords = attendance.slice(-8); // Get the last 8 records
            setAttendanceRecords(lastFiveRecords);
        }

        const initializeData = async () => {
            await loadUserDetails();
            await loadAttendanceData();
            await loadAllAttendanceData();
        }

        // Calls the functions above
        initializeData();

    }, [currentDate2]);

    useEffect(() => {
        const calculateAllPercentages = async () => {
            const percentages = {};
            const staff = users.filter(user => 
                user.group === "Vice Principal" || 
                user.group === "Principal" || 
                user.group === "Male Teacher" || 
                user.group === "Female Teacher" || 
                user.group === "Admin Staff"
            );
            for (const user of staff) {
                const perc = await calculatePercentages(user.id);
                percentages[user.id] = perc;
                // setPercentages(percentages); // Uncomment for slower db, Updates Percentages one by one 
            }
            setPercentages(percentages); // Uncomment for Faster DB, updates all at once, both work but to not confuse users using above in slow db
            
        }

        if (users.length > 0) {
            calculateAllPercentages();
        }

    }, [users]);


    const handleSearch = async (event) => {
        setSearch(event.target.value.toLowerCase());
    }

    const handleAttendanceChange = async (staffId, status, staffGroup) => {

        let updatedAttendanceData = attendanceData.map((staff) => {
            if (staff && staff.id === staffId) {
                return { ...staff, status };
            }
            return staff;
        });

        const existingAttendance = await getAttendance(currentDate2);;

        if (existingAttendance) {
            const existingstaff = updatedAttendanceData.find((staff) => staff?.id === staffId);
            if (!existingstaff) {
                updatedAttendanceData.push({
                    id: staffId,
                    group: staffGroup,
                    status: status,
                });
            }
        } else {
            updatedAttendanceData = [
                ...attendanceData,
                {
                    id: staffId,
                    group: staffGroup,
                    status: status,
                },
            ];
        }

        setAttendanceData(updatedAttendanceData);
        await syncAttendanceData(updatedAttendanceData);

        const percentages = await calculatePercentages(staffId);

        // Update the percentages state
        setPercentages(prevPercentages => ({
            ...prevPercentages,
            [staffId]: percentages
        }));

    };

    const syncAttendanceData = async (updatedAttendanceData) => {
        const existingAttendance = await getAttendance(currentDate2);

        if (existingAttendance) {
            await updateAttendance(currentDate2, updatedAttendanceData);
        } else {
            await createAttendance(currentDate2, updatedAttendanceData);
        }

        const attendance = await getAllAttendance();
        const lastFiveRecords = attendance.slice(-8); // Get the last 8 records
        setAttendanceRecords(lastFiveRecords);
    };

    // Calculate present and absent percentages
    const calculatePercentages = async (staffId) => {
        
        const newAttendanceData2 = await getAllAttendance();

        let totalAttendance = 0;
        let presentCount = 0;
        let absenceCount = 0;
        let approvedLeaveCount = 0;

        newAttendanceData2.forEach((record) => {
            record.attendance.forEach((staff) => {
                if (staff.id === staffId) {
                    totalAttendance++;
                    if (staff.status === "Present") {
                        presentCount++;
                    } else if (staff.status === "Absent") {
                        absenceCount++;
                    } else if (staff.status === "Approved Leave") {
                        approvedLeaveCount++;
                    }
                }
            });
        });

        // Add 15% to the present count for approved leave
        presentCount += approvedLeaveCount * 0.15;

        return {
            presentPercentage: totalAttendance > 0 ? (presentCount / totalAttendance) * 100 : 0,
            absencePercentage: totalAttendance > 0 ? (absenceCount / totalAttendance) * 100 : 0,
        };
    };


    return (

        <div>
            <p>&nbsp;</p>
            <h3 className="text-center">Mark Attendance:</h3>

            <br />
            <div className="searchCenter">
                <div className="form-group has-search">
                    <span className="fa fa-search form-control-feedback"></span>
                    <input type="text" style={{ border: "1px solid #112c3f", borderRadius: "10rem" }} className="form-control" placeholder="Search" aria-label="Search" onChange={handleSearch} />
                </div>
            </div>
            
            {(props.user.group === "Admin" || (props.user.group === "Principal" && props.user.gender === "Male")) && (
                <div style={{ textAlign: "center", margin: "0.5rem" }}>
                    <select style={{ border: "1px solid #112c3f", borderRadius: "0.5rem", padding: "0.25rem 0.5rem" }} value={genderFilter} onChange={(e) => setGenderFilter(e.target.value)}>
                        <option value="All">All</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <div style={{ fontSize: "0.75rem", color: "#555", marginTop: "0.25rem" }}>
                        Gender
                    </div>
                </div>
            )}

            <div className="table-responsive">

                {isLoading ?
                    <div className="card-body text-center">
                        <span className="text-muted">Loading Staff...</span>
                    </div>
                    :
                    <div>
                        <table className="table table-striped" style={{ margin: "0" }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th style={{ color: "#112c3f" }} scope="col">ID</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Name</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Group</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Gender</th>
                                    <th className="text-center" style={{ color: "#112c3f" }} scope="col">Mark Attendance</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Last 8 Attendances</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Total Absences</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Total Presents</th>

                                </tr>
                            </thead>
                            {/* Mapping Users state Variable to access its content easily to display in Table */}
                            {users.filter((userDetails) => {
                                return search.toLowerCase() === '' ? userDetails : (userDetails.name && userDetails.name.toLowerCase().includes(search)) || (userDetails.group && userDetails.group.toLowerCase().includes(search)) || (userDetails.id && userDetails.id.toLowerCase().includes(search)) || (userDetails.gender && userDetails.gender.toLowerCase().includes(search));
                            }).map((userDetails) => {
                                // Check if the staff ID exists in the attendanceData array
                                const attendancestaff = attendanceData.find((staff) => staff.id === userDetails.id);

                                // Get the status if the staff exists in the attendanceData array
                                const status = attendancestaff ? attendancestaff.status : "";

                                const lastFiveAttendances = attendanceRecords.map(record => record.attendance.find(staff => staff.id === userDetails.id));
                                const attendanceStatus = lastFiveAttendances
                                    .map((record) => {
                                        if (record) {
                                            if (record.status === "Present") {
                                                return "✅";
                                            } else if (record.status === "Absent") {
                                                return "❌";
                                            } else if (record.status === "Approved Leave") {
                                                return "🟠";
                                            }
                                        }
                                        return "🚫";
                                    })
                                    // .reverse()
                                    .join("");

                                // Get the percentages for the student
                                const studentPercentages = percentages[userDetails.id] || { presentPercentage: 0, absencePercentage: 0 };

                                return (
                                    <tbody key={userDetails.id}>
                                        {/* Dont display the name of the logged in user and the System Admin but the rest of the staff */}
                                        {((userDetails.id !== "MAAdminAcc") &&
                                            (
                                                (props.user.group === "Admin" &&
                                                    (userDetails.group === "Male Teacher" || userDetails.group === "Female Teacher" || userDetails.group === "Principal" || userDetails.group === "Admin" || userDetails.group === "Vice Principal" || userDetails.group === "Admin Staff")
                                                ) ||
                                                (
                                                    (props.user.group === "Principal" && props.user.gender === "Female") &&
                                                    (userDetails.group === "Female Teacher" || userDetails.id === props.user.id || (userDetails.group === "Admin Staff" && userDetails.gender === "Female") || (userDetails.group === "Vice Principal" && userDetails.gender === "Female"))
                                                ) ||
                                                (
                                                    (props.user.group === "Principal" && props.user.gender === "Male") &&
                                                    (userDetails.group === "Male Teacher" || userDetails.group === "Female Teacher" || userDetails.group === "Principal" || userDetails.group === "Vice Principal" || userDetails.group === "Admin Staff")
                                                    // (userDetails.group === "Male Teacher" || userDetails.id === props.user.id || (userDetails.group === "Admin Staff" && userDetails.gender === "Male") || (userDetails.group === "Vice Principal" && userDetails.gender === "Male"))
                                                ) ||
                                                (
                                                    (props.user.group === "Admin Staff" && props.user.gender === "Male") &&
                                                    (userDetails.group === "Male Teacher" || userDetails.id === props.user.id || (userDetails.group === "Admin Staff" && userDetails.gender === "Male") || (userDetails.group === "Vice Principal" && userDetails.gender === "Male") || (userDetails.group === "Principal" && userDetails.gender === "Male"))
                                                ) ||
                                                (
                                                    (props.user.group === "Admin Staff" && props.user.gender === "Female") &&
                                                    (userDetails.group === "Female Teacher" || userDetails.id === props.user.id || (userDetails.group === "Admin Staff" && userDetails.gender === "Female") || (userDetails.group === "Vice Principal" && userDetails.gender === "Female") || (userDetails.group === "Principal" && userDetails.gender === "Female"))
                                                ) ||
                                                (
                                                    (props.user.group === "Vice Principal" && props.user.gender === "Female") &&
                                                    (userDetails.group === "Female Teacher" || userDetails.id === props.user.id || (userDetails.group === "Admin Staff" && userDetails.gender === "Female") || (userDetails.group === "Vice Principal" && userDetails.gender === "Female") || (userDetails.group === "Principal" && userDetails.gender === "Female"))
                                                ) ||
                                                (
                                                    (props.user.group === "Vice Principal" && props.user.gender === "Male") &&
                                                    (userDetails.group === "Male Teacher" || userDetails.id === props.user.id || (userDetails.group === "Admin Staff" && userDetails.gender === "Male") || (userDetails.group === "Vice Principal" && userDetails.gender === "Male") || (userDetails.group === "Principal" && userDetails.gender === "Male"))
                                                )
                                            )
                                        ) &&
                                            ((props.user.group === "Admin" || (props.user.group === "Principal" && props.user.gender === "Male"))
                                                ? (genderFilter === "All" || userDetails.gender?.toLowerCase() === genderFilter.toLowerCase()) : true) &&  
                                            <>
                                                <tr>
                                                    <td></td>
                                                    <td style={{ color: "#112c3f" }}>{userDetails.id}</td>
                                                    <td style={{ color: "#112c3f" }}>{userDetails.name}</td>
                                                    {userDetails.group === "Principal" && userDetails.gender === "Female" ? (
                                                        <td style={{ color: "#112c3f" }}>In Charge Girls Section</td>
                                                    ) : userDetails.group === "Vice Principal" && userDetails.gender === "Female" ? (
                                                        <td style={{ color: "#112c3f" }}>Vice In Charge Girls Section</td>
                                                    ) : (
                                                        <td style={{ color: "#112c3f" }}>{userDetails.group}</td>
                                                    )}
                                                    <td style={{ color: "#112c3f" }}>{userDetails.gender}</td>
                                                    <td style={{ color: "#112c3f" }}>
                                                        <div className="attendance-buttons">
                                                            <button className={`attendance-button ${status === "Present" ? "selected present" : "present"}`} onClick={() => handleAttendanceChange(userDetails.id, "Present", userDetails.group)}>Present</button>
                                                            <button className={`attendance-button ${status === "Absent" ? "selected absent" : "absent"}`} onClick={() => handleAttendanceChange(userDetails.id, "Absent", userDetails.group)}>Absent</button>
                                                            <button className={`attendance-button ${status === "Approved Leave" ? "selected approved" : "approved"}`} onClick={() => handleAttendanceChange(userDetails.id, "Approved Leave", userDetails.group)}>Approved Leave</button>
                                                        </div>
                                                    </td>
                                                    {/* <td style={{ color: "#112c3f" }}>➡{attendanceStatus}</td> */}
                                                    <td style={{ color: "#112c3f", verticalAlign: "top" }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span>➡</span>
                                                            <span>{attendanceStatus}</span>
                                                        </div>
                                                    </td>
                                                    <td style={{ color: "#112c3f" }}>{studentPercentages.absencePercentage.toFixed(2)}%</td>
                                                    <td style={{ color: "#112c3f" }}>{studentPercentages.presentPercentage.toFixed(2)}%</td>

                                                </tr>
                                            </>
                                        }
                                    </tbody>
                                )
                            })}
                        </table>
                    </div>
                }
            </div>
        </div>
    );
}

// Export the Attendance Function
export default Attendance;
